import React, { useState, useEffect } from 'react'
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  Modal,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { addBillAdd, editBillAdd, fetchCountryAndStatesList, resetCardAlert, setPayementInformation } from "../../../../store/actions"
import CustomLoader from '../../../Common/CustomLoader'
import SmallLoader from '../../../Common/SmallLoader'
import form_messages from '../../../../constants/form_messages'
import { CustomToast } from '../../Common/CustomToast'
import form_input_patterns from '../../../../constants/form_input_patterns'
import PasswordToolTip from '../../../Common/PasswordToolTip'
import CustomPopup from '../../../Common/CustomPopup'
import { isEqual } from 'lodash'
import BillingAdressFields from './BillingAdressFields'
import { useNavigate } from 'react-router-dom'

export const BillingAddress = ({ hideHeading, billAddress, getBillAddressLoading, editBillAddressLoading, billAddressLoading, editBillAddErr, repMessage = null, addBillAddErr, closeModal, setBillFetched, validationShape, validationType, setValidationShape, initialValidationShape, initialValuesForForm }) => {
  const dispatch = useDispatch()

  const [error, setIsError] = useState(false)
  const [edited, setedited] = useState(false)
  const CountryState = useSelector(state => state.Account?.countryAndStates)
  const { loading, list: countryList } = CountryState || {}
  const { billingCntry } = useSelector(state => state.Login.constDetails)
  const [popupDetails, setPopupDetails] = useState({ open: false })
  const gstInregex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
  const [statesList, setStatesList] = useState([])
  const BillingState = useSelector(state => state.BillSet)
  const { setPayementInfo, cardList } = BillingState
  const navigate = useNavigate();
  const [popupopen, setPopupOpen] = useState(false)

  useEffect(() => {
    if (countryList?.length === 0 && ((!edited && !billAddress && !getBillAddressLoading) || (edited && billAddress && !getBillAddressLoading))) {
      dispatch(fetchCountryAndStatesList({}))
    }
  }, [edited, billAddress, getBillAddressLoading])



  useEffect(() => {
    if (setPayementInfo?.cancelCardDetails && !popupDetails.open) {
      onClickCancel();
    }

  }, [setPayementInfo?.cancelCardDetails, popupDetails])

  useEffect(() => {
    if (validationType.values?.country_name) {
      let states = countryList?.find(obj => obj.CountryName === validationType.values?.country_name)?.States
      setStatesList(states)
      if (states?.length === 0) {
        setValidationShape(
          validationShape.shape({
            state: Yup.string().trim()
              // .matches(
              //   form_input_patterns.ONLYENGLISHTEXT,
              //   form_messages.Common.INVALID("State")
              // )
              .min(2, form_messages.Billing_Address.State.MIN2MAX100)
              .max(100, form_messages.Billing_Address.State.MIN2MAX100)
          })
        );
      } else {
        setValidationShape(initialValidationShape);
      }

    }
  }, [validationType.values?.country_name, countryList])

  useEffect(() => {
    if (repMessage !== null && editBillAddErr !== null) {
      CustomToast({
        message: repMessage,
        status: editBillAddErr ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      if (!editBillAddErr) {
        setedited(false)
      }

    }
    if (repMessage !== null && addBillAddErr !== null) {
      CustomToast({
        message: repMessage,
        status: addBillAddErr ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      if (!addBillAddErr && cardList.count > 0) {
        setedited(false)
      }
    }
    dispatch(resetCardAlert())
  }, [editBillAddErr, addBillAddErr, cardList])

  const onClickDiscard = () => {
    setedited(false)
    validationType.resetForm()
    setPopupDetails({ open: false })
    dispatch(setPayementInformation({ cancelCardDetails: false, from: null }))
    if (cardList?.count == 0 && !billAddress) {
      navigate('/dashboard')
    }

  }

  const handleCloseDiscardPopup = () => {
    setPopupDetails({ open: false })
    dispatch(setPayementInformation({ cancelCardDetails: false, from: null }))

  }

  const onClickCancel = () => {
    const isValuesNotChanged = isEqual(validationType.values, initialValuesForForm)
    if (isValuesNotChanged && setPayementInfo?.from !== "card") {
      onClickDiscard();
    }
    else {
      if (billAddress) {
        onClickDiscard();

      }
      else {
        setPopupDetails({
          open: true, title: 'accountModification', titleText: 'Discard',
          bodyText: <div className='payment-discard'><p>You have unsaved information in this page.</p><p>Are you sure you want to discard?</p></div>,
          primaryButtonText: 'Discard', secondaryButtonText: 'Cancel', handleClickPrimaryButton: onClickDiscard, handleClose: handleCloseDiscardPopup, handleClickSecondaryButton: handleCloseDiscardPopup
        })
      }

    }
  }


  return (
    <React.Fragment>
      {getBillAddressLoading ? <div className='mt-3'><CustomLoader text={"Fetching billing address..."} /></div> : <div className="billing-address-details">
        {!hideHeading && (
          <div >
            <div className="billing-details d-flex align-items-center justify-content-between">
              <span className="title">{billAddress ? "Saved address" : "Billing address"}</span>
              <div className='d-flex'>
                {(edited && !setPopupOpen) && <button className='btn-cancel' type='button' onClick={() => {
                  onClickCancel();
                }}>Cancel</button>}
                {((!edited || edited && setPopupOpen) && billAddress) && <button className="button" type='button' onClick={(e) => {
                  setedited(true)
                  setPopupOpen(true)
                  return false
                }}>Edit billing address</button>}
                {(edited && billAddress && !setPopupOpen) && <button disabled={editBillAddressLoading} className={`${editBillAddressLoading ? "btn-save me-0 button-disabled" : "btn-save me-0"}`} type='submit' onClick={(e) => {
                  e.preventDefault()
                  validationType.handleSubmit()
                  return false
                }}>Save
                  {/* {editBillAddressLoading ? <SmallLoader /> : `Save`} */}
                  {editBillAddressLoading &&
                    <div className="spinner-container spinner-border">
                    </div>}
                </button>}
              </div>
            </div>
          </div>
        )}

        <div>
          {
            (billAddress && edited) ?
              <>
                <Modal
                  className="model-card billing-address mx-auto"
                  isOpen={edited}
                  // toggle={() => {
                  //   // tog_center()
                  // }}
                  centered={true}
                >
                  <div className="model-header-custom">
                    <span className="title">Edit billing address</span>
                    <button
                      type="button"
                      onClick={() => {
                        onClickDiscard();

                      }}
                      className="close button"
                      data-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <Form
                    className='form-billing-address edited custom-validation'
                  >

                    <BillingAdressFields from="popup" validationType={validationType} billAddress={billAddress} edited={edited} statesList={statesList} countryList={countryList} setPayementInfo={setPayementInfo} />

                  </Form>
                  <div className='save-card-btn'>
                    {edited && <button className='btn-cancel' type='button' onClick={() => {
                      onClickCancel();
                    }}>Cancel</button>}
                    {(edited && billAddress) && <button disabled={editBillAddressLoading} className={`${editBillAddressLoading ? "btn-save me-0 button-disabled" : "btn-save me-0"}`} type='submit' onClick={(e) => {
                      e.preventDefault()
                      validationType.handleSubmit()
                      return false
                    }}>Save
                      {/* {editBillAddressLoading ? <SmallLoader /> : `Save`} */}
                      {editBillAddressLoading &&
                        <div className="spinner-container spinner-border">
                        </div>}
                    </button>}
                  </div>
                </Modal>
                <Form
                  className='form-billing-address custom-validation'
                >

                  <BillingAdressFields validationType={validationType} billAddress={billAddress} edited={edited} statesList={statesList} countryList={countryList} />
                </Form>
              </>
              :
              <Form
                className='form-billing-address custom-validation'
              >

                <BillingAdressFields validationType={validationType} billAddress={billAddress} edited={edited} statesList={statesList} countryList={countryList} />
              </Form>
          }

          {hideHeading && (
            <div className="save-billing-card-btn mt-3">
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  closeModal()
                }}
              >
                Cancel
              </button>
              <button className="btn-save me-0" disabled={billAddressLoading} type='submit' onClick={(e) => {
                e.preventDefault()
                validationType.handleSubmit()
                return false
              }}>{billAddressLoading ? <SmallLoader /> : `Add Address`}</button>
            </div>
          )}
        </div >
        {popupDetails.open &&
          <CustomPopup
            popupDetails={popupDetails}
          />
        }
      </div >}
    </React.Fragment >
  )
}
